// 辖区管理
import axios from '@/utils/axios'

const rootUrl = 'jurisdiction/website/jurisdiction/'

const api = {
  ClientList: rootUrl + 'clientList'
}

/**
 * 辖区列表接口
 */
export function getClientList(parameter) {
  return axios.formRequest.post(api.ClientList, parameter)
}

/**
 * 辖区列表接口
 */
export function editLeaderTemplate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/editLeaderTemplate',
    parameter
  )
}

/**
 * 共坑下载模版
 */
export function jurisdictionExportPit(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/jurisdiction/exportPit',
    parameter
  )
}
/**
 * 关联关系自动关联保存
 */
export function relationSave(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/relationSave',
    parameter
  )
}
/**
 * 关联关系错误列表
 */
export function relationErrorLog(relation_log_id) {
  return axios.formRequest.post(
    'jurisdiction/website/target/relationErrorLog',
    { relation_log_id }
  )
}
/**
 * 关联关系日志列表
 */
export function relationLog(param) {
  return axios.formRequest.post(
    'jurisdiction/website/target/relationLog',
    param
  )
}
/**
 * 关联关系配置保存
 */
export function globalSave(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/globalSave',
    parameter
  )
}
/**
 * 关联关系配置详情 7 等级配置 12 关联关系产品配置类型
 */
export function globalSetting(type) {
  return axios.formRequest.post('masterdata/website/Setting/globalSetting', {
    type
  })
}

/**
 * 正式潜在标签，立即处理
 */
export function doItNow(parameter = {}) {
  return axios.formRequest.post('masterdata/website/setting/doItNow', parameter)
}

/**
 * 获取销售指标设置
 */
export function getSaleIndexConfig() {
  return axios.formRequest.post(
    'jurisdiction/website/setting/getSaleIndexConfig',
    {}
  )
}

/**
 * 获取销售指标设置
 */
export function savelIndexConfig(setting) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/savelIndexConfig',
    { setting }
  )
}

/**
 * 按部门统计销售指标列表
 */
export function saleIndexByDepartmentPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByDepartmentPage',
    parameter
  )
}

/**
 * 按部门统计销售指标详情
 */
export function saleIndexByDepartmentInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByDepartmentInfo',
    parameter
  )
}

/**
 * 按部门统计销售指标列表导出
 */
export function exportSaleIndexDepartment(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexDepartment',
    parameter
  )
}

/**
 * 按部门统计销售指标详情导出
 */
export function exportSaleIndexDepartmentInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexDepartmentInfo',
    parameter
  )
}

/**
 * 按终端统计销售指标列表
 */
export function saleIndexByClientPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByClientPage',
    parameter
  )
}

/**
 * 按终端统计销售指标详情
 */
export function saleIndexByClientInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByClientInfo',
    parameter
  )
}

/**
 * 按终端统计销售指标列表导出
 */
export function exportSaleIndexClient(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexClient',
    parameter
  )
}

/**
 * 按终端统计销售指标详情导出
 */
export function exportSaleIndexClientInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexClientInfo',
    parameter
  )
}

/**
 * 按产品统计销售指标列表
 */
export function saleIndexByGoodsPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByGoodsPage',
    parameter
  )
}

/**
 * 按产品统计销售指标详情
 */
export function saleIndexByGoodsInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByGoodsInfo',
    parameter
  )
}

/**
 * 按产品统计销售指标列表导出
 */
export function exportSaleIndexGoods(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexGoods',
    parameter
  )
}

/**
 * 按产品统计销售指标详情导出
 */
export function exportSaleIndexGoodsInfo(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexGoodsInfo',
    parameter
  )
}
/**
 * 获取档案的二者关系列表
 */
export function getChargeList(client_id) {
  return axios.formRequest.post('jurisdiction/website/target/getChargeList', {
    client_id
  })
}
/**
 * 变更辖区负责人接口
 */
export function changeJurisdiction(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/changeJurisdiction',
    parameter
  )
}

/**
 * 导出更新医生负责人
 */
export function exportDoctorQuarter(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportDoctorQuarter',
    parameter
  )
}

/**
 * 选择产品 优化
 */
export function getCategoriesListSaleindex(index_type) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/getCategoriesList',
    { index_type }
  )
}

/**
 * 获取历史部门集合
 */
export function getAllDpHistory(date) {
  return axios.formRequest.post(
    'jurisdiction/website/department/getAllDpHistory',
    { date }
  )
}

/**
 * 部门人员搜索
 * name, date
 */
export function searchDpHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/searchDpHistory',
    parameter
  )
}

/**
 * 部门详情
 * department_id, date
 */
export function getDpInfoHistory(department_id, date) {
  return axios.formRequest.post(
    'jurisdiction/website/department/getDpInfoHistory',
    { department_id, date }
  )
}

/**
 * 部门下人员信息
 * department_id, date
 */
export function getQuartersListHistory(department_id, date) {
  return axios.formRequest.post(
    'jurisdiction/website/department/getQuartersListHistory',
    { department_id, date }
  )
}

/**
 * 三者关系维护部门搜索
 * name
 */
export function departmentSearch(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/search',
    parameter
  )
}

/**
 * 三者关系涉及月份
 */
export function clientHistoryMonth() {
  return axios.formRequest.post(
    'jurisdiction/website/department/clientHistoryMonth',
    {}
  )
}

/**
 * 历史三者关系
 */
export function getClientListHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/jurisdiction/clientListHistory',
    parameter
  )
}

/**
 * 三者关系维护部门搜索（历史）
 * name date
 */
export function departmentSearchHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/searchHistory',
    parameter
  )
}

/**
 * 按档案统计销售指标导出
 */
export function exportExportSaleIndexClient(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexClient',
    parameter
  )
}

/**
 * 按部门统计销售指标导出
 */
export function exportExportSaleIndexDepartment(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexDepartment',
    parameter
  )
}
/**
 * 按岗位统计销售指标导出
 */
export function exportExportSaleIndexQuarter(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexQuarter',
    parameter
  )
}

/**
 * 按产品统计销售指标导出
 */
export function exportExportSaleIndexGoods(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexGoods',
    parameter
  )
}

/**
 * 下载市场部关联模版
 */
export function clientMaketGetTemplate(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_maket/getTemplate',
    parameter
  )
}

/**
 * 指标金额计算
 */
export function saleIndexByClientTotal(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/saleIndexByClientTotal',
    parameter
  )
}

/**
 *  关联关系生效时间配配置
 */
export function setSaleIndexTitle(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/setSaleIndexTitle',
    parameter
  )
}

/**
 * 历史部门导出
 * title_search, date
 */
export function exportHistoryAsync(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportHistory',
    parameter
  )
}

/**
 *  共岗终端备案导入
 */
export function downloadShareQuarterTemplate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/downloadShareQuarterTemplate',
    parameter
  )
}

/**
 *  导出岗位/产品/终端关联数据
 */
export function exportClientShare(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/exportClientShare',
    parameter
  )
}

/**
 *  共岗终端备案比例下载模版
 */
export function downloadShareQuarterRateTemplate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/downloadShareQuarterRateTemplate',
    parameter
  )
}

/**
 *  共岗产品页面设置详情
 */
export function setClientShareRateGoods(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/setClientShareRateGoods',
    parameter
  )
}

/**
 *  共岗产品比例设置
 */
export function addClientShareRate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/addClientShareRate',
    parameter
  )
}

/**
 * 指标金额计算
 */
export function newSaleIndexByClientTotal(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/saleIndexByClientTotal',
    parameter
  )
}

/**
 * 按部门统计销售指标导出(新)
 */
export function exportNewSaleIndexDepartment(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportNewSaleIndexDepartment',
    parameter
  )
}

/**
 * 按档案统计销售指标导出(新)
 */
export function exportNewSaleIndexClient(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportNewSaleIndexClient',
    parameter
  )
}

/**
 * 按岗位统计销售指标导出
 */
export function exportNewSaleIndexQuarter(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportNewSaleIndexQuarter',
    parameter
  )
}

/**
 * 历史三者关系生效时间列表
 */
export function clientGoodsQuarterHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/jurisdiction/clientGoodsQuarterHistory',
    parameter
  )
}

/**
 * 历史二者关系生效时间列表
 */
export function clientQuarterHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/jurisdiction/clientQuarterHistory',
    parameter
  )
}
/**
 * 商业备案列表
 */
export function businessRecordPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_record/page',
    parameter
  )
}
/**
 * 商业备案导出
 */
export function businessRecordExport(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_record/export',
    parameter
  )
}
/**
 * 商业备案删除
 */
export function businessRecordDelete(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_record/del',
    parameter
  )
}
/**
 * 商业备案筛选列表
 */
export function businessRecordScreenList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_record/screenList',
    parameter
  )
}
/**
 * 辖区指标分配
 */
export function devolveIndexSummary(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/devolveIndexSummary',
    parameter
  )
}
/**
 * 辖区指标分配
 */
export function devolveIndexClientSummary(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/devolveIndexClientSummary',
    parameter
  )
}

/**
 * 销售岗位按产品标签指标进度查询
 */
export function getSaleQuarterList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/sale_quarter_index/getList',
    parameter
  )
}
/**
 * 指标进度查询 按终端
 */
export function getSaleClientList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/sale_client_index/getList',
    parameter
  )
}

/**
 * 关联关系字段列表
 */
export function relationFieldList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/relationFieldList',
    parameter
  )
}

/**
 * 关联关系自定义字段是否启用
 */
export function RelationOpenField(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/openField',
    parameter
  )
}

/**
 * 关联关系字段编辑
 */
export function RelationeditField(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/editField',
    parameter
  )
}

/**
 * 关联关系只保存产品类型的接口
 */
export function RelationeditGoodsType(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/editGoodsType',
    parameter
  )
}

/**
 * 关联关系维护列表
 */
export function relationMapPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/relationMapPage',
    parameter
  )
}
/**
 * 数据关系维护列表
 */
export function relationMap2Page(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/relationMap2Page',
    parameter
  )
}

/**
 * 数据关系维护列表
 */
export function getOpenField(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation/getOpenField',
    parameter
  )
}
/**
 * 分类列表
 */
export function getCategoriesListByLevel(parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getCategoriesListByLevel',
    parameter
  )
}

/**
 * 分类列表
 */
export function getPlanListForSelectClient() {
  return axios.formRequest.post(
    'jurisdiction/website/relation_members/getPlanListForSelectClient'
  )
}
/**
 * 关系成员映射列表接口
 */
export function getRelationMembersMapList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation_members/getRelationMembersMapList',
    parameter
  )
}

/**
 * 关系方案分页列表+异步导出接口
 */
export function getRelationPlanPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation_members/getRelationPlanPage',
    parameter
  )
}
/**
 * 关系成员分页列表+异步导出接口
 */
export function getRelationMembersPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation_members/getRelationMembersPage',
    parameter
  )
}
/**
 * 关系数据分页列表+异步导出接口
 */
export function getRelationDataPage(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/relation_members/getRelationDataPage',
    parameter
  )
}
/**
 * 商业备案关系-按终端分页列表 + 异步导出
 */
export function getClientPageList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/getClientPageList',
    parameter
  )
}

/**
 * 商业备案关系-按区域分页列表 + 异步导出
 */
export function getRegionPageList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/getRegionPageList',
    parameter
  )
}

/**
 * 更新商业备案关系模版下载
 */
export function upDatesynExportClientTemplate(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/synExportClientTemplate',
    parameter
  )
}

/**
 * 新增商业备案关系-按区域
 */
export function addBusinessFilingRegion(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/addBusinessFilingRegion',
    parameter
  )
}

/**
 * 编辑商业备案关系-按区域
 */
export function editBusinessFilingRegion(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/editBusinessFilingRegion',
    parameter
  )
}

/**
 * 删除商业备案关系-按区域
 */
export function delBusinessFilingRegion(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/business_filing_relation/delBusinessFilingRegion',
    parameter
  )
}


